export enum FormDetailStepModelType {
  instruction = 0,
  process = 1
}